import * as React from 'react';

import styles from './styles.module.scss';


interface VenueNotesProps {
    venueNotes: string;
}


const VenueNotes = (props: VenueNotesProps) => {
    const { venueNotes } = props;

    return (
        <div className={styles.wrapper}>
            <h2>Venue Notes</h2>
            {venueNotes}
        </div>
    );
};

export default VenueNotes
